import { NgModule } from '@angular/core';
import { AutosizeModule } from 'ngx-autosize';
import { MomentModule } from 'ngx-moment';
import { SupportServiceTypesComponent } from 'src/app/pages/agreements/shared/components/support-service-types/support-service-types.component';
import { PrefillLmjInfoFromSessionBannerComponent } from 'src/app/pages/flex/components/prefill-lmj-info-from-session-banner/prefill-lmj-info-from-session-banner.component';
import { LastMinuteJobRateComponent } from 'src/app/pages/flex/pages/jobs/components/last-minute-job-rate.component';
import { MomentDisplayModule } from 'src/app/shared/components/moment-display/moment-display.module';
import { RatesInfoBannerComponent } from 'src/app/shared/components/rates-info-banner/rates-info-banner.component';
import { TipComponent } from 'src/app/shared/components/tip/tip.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CancelBookingComponent } from './components/cancel-booking/cancel-booking.component';
import { CancelJobComponent } from './components/cancel-job/cancel-job.component';
import { CancellationPolicyComponent } from './components/cancellation-policy/cancellation-policy.component';
import { ClientFlexJobListItemComponent } from './components/client-flex-job-list-item/client-flex-job-list-item.component';
import { ClientFlexJobTimelineComponent } from './components/client-flex-job-timeline/client-flex-job-timeline.component';
import { ConfirmBookingComponent } from './components/confirm-booking/confirm-booking.component';
import { CreateJobButtonComponent } from './components/create-job-button/create-job-button.component';
import { FlexJobInfoSummaryComponent } from './components/flex-job-info-summary/flex-job-info-summary.component';
import { FlexJobSummaryComponent } from './components/job-summary/job-summary.component';
import { MessageButtonComponent } from './components/message-button/message-button.component';
import { NotificationFlexAvailabilityModal } from './components/notification-flex-availability/notification-flex-availability.component';
import { WorkerBidComponent } from './components/worker-bid/worker-bid.component';
import { FlexRoutingModule } from './flex-routing.module';
import { CarerBookedJobPage } from './pages/jobs/booked/carer/carer.page';
import { ConsumerBookedJobPage } from './pages/jobs/booked/consumer/consumer.page';
import { FlexJobInfoComponent } from './pages/jobs/create/flex-job-info/flex-job-info.component';
import { FlexJobFormPage } from './pages/jobs/create/form/form.page';
import { CarerOpenJobPage } from './pages/jobs/open/carer/carer.page';
import { ConsumerOpenJobPage } from './pages/jobs/open/consumer/consumer.page';

@NgModule({
  declarations: [
    FlexJobInfoComponent,
    CreateJobButtonComponent,
    FlexJobInfoSummaryComponent,
    FlexJobFormPage,
    CarerOpenJobPage,
    ConsumerOpenJobPage,
    ClientFlexJobTimelineComponent,
    ConsumerBookedJobPage,
    CarerBookedJobPage,
    CancellationPolicyComponent,
    NotificationFlexAvailabilityModal,
    FlexJobSummaryComponent,
    WorkerBidComponent,
    MessageButtonComponent,
    ConfirmBookingComponent,
    CancelBookingComponent,
    CancelJobComponent,
    ClientFlexJobListItemComponent,
    PrefillLmjInfoFromSessionBannerComponent,
  ],
  imports: [
    FlexRoutingModule,
    AutosizeModule,
    SharedModule,
    MomentModule,
    MomentDisplayModule,
    LastMinuteJobRateComponent,
    SupportServiceTypesComponent,
    RatesInfoBannerComponent,
    TipComponent,
  ],
  exports: [
    CancellationPolicyComponent,
    FlexJobInfoComponent,
    CreateJobButtonComponent,
    FlexJobInfoSummaryComponent,
    FlexJobFormPage,
    CarerOpenJobPage,
    ConsumerOpenJobPage,
    ClientFlexJobTimelineComponent,
    ConsumerBookedJobPage,
    CarerBookedJobPage,
    CancellationPolicyComponent,
    NotificationFlexAvailabilityModal,
    FlexJobSummaryComponent,
    WorkerBidComponent,
    MessageButtonComponent,
    ConfirmBookingComponent,
    CancelBookingComponent,
    CancelJobComponent,
    ClientFlexJobListItemComponent,
  ],
})
export class FlexModule {}
